/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FamilyPoolRelationship
 */
export interface FamilyPoolRelationship {
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolRelationship
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolRelationship
     */
    peerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolRelationship
     */
    peerName: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolRelationship
     */
    peerEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof FamilyPoolRelationship
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the FamilyPoolRelationship interface.
 */
export function instanceOfFamilyPoolRelationship(value: object): value is FamilyPoolRelationship {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('peerUserId' in value) || value['peerUserId'] === undefined) return false;
    if (!('peerName' in value) || value['peerName'] === undefined) return false;
    if (!('peerEmail' in value) || value['peerEmail'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function FamilyPoolRelationshipFromJSON(json: any): FamilyPoolRelationship {
    return FamilyPoolRelationshipFromJSONTyped(json, false);
}

export function FamilyPoolRelationshipFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyPoolRelationship {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'peerUserId': json['peer_user_id'],
        'peerName': json['peer_name'],
        'peerEmail': json['peer_email'],
        'createdAt': (new Date(json['created_at'])),
    };
}

export function FamilyPoolRelationshipToJSON(json: any): FamilyPoolRelationship {
    return FamilyPoolRelationshipToJSONTyped(json, false);
}

export function FamilyPoolRelationshipToJSONTyped(value?: FamilyPoolRelationship | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'peer_user_id': value['peerUserId'],
        'peer_name': value['peerName'],
        'peer_email': value['peerEmail'],
        'created_at': value['createdAt'].toISOString(),
    };
}

